__turbopack_context__.v({
  "card": "Disclaimer-module-scss-module__tfmsMG__card",
  "cardBody": "Disclaimer-module-scss-module__tfmsMG__cardBody",
  "icon": "Disclaimer-module-scss-module__tfmsMG__icon",
  "mobile": "Disclaimer-module-scss-module__tfmsMG__mobile",
  "text": "Disclaimer-module-scss-module__tfmsMG__text",
});
